import { ChakraProps } from "@chakra-ui/react";
import React, { useCallback } from "react";
import useExperiments from "../../hooks/quests/useExperiments";
import { AsyncSearchProvider } from "./AsyncSearchProvider";
import AsyncSelect from "./AsyncSelect";

interface SelectExperimentProps extends ChakraProps {
  value: string;
  setValue: (value: string) => void;
}

const SelectExperiment: React.FC<SelectExperimentProps> = ({ color, value, setValue, ...chakraProps }) => {
  const { isLoading, error, experiments = [] } = useExperiments();

  const handleSearch = useCallback(
    async (searchQuery?: string): Promise<[string, string][]> => {
      return experiments
        .filter((experiment) => experiment.experimentId.toLowerCase().includes(searchQuery?.toLowerCase().trim() ?? ""))
        .map((experiment) => [experiment.experimentId, experiment.experimentId]);
    },
    [experiments]
  );

  return (
    <AsyncSearchProvider onSearchAsync={handleSearch}>
      <AsyncSelect
        selectedValue={value}
        setSelectedValue={setValue}
        title={"Experiment"}
        color={color}
        isLoading={isLoading}
        error={error}
        {...chakraProps}
      />
    </AsyncSearchProvider>
  );
};

export default SelectExperiment;
